export default __webpack_public_path__ + "static/media/flowers.3bd733f2.jpeg";